import { h } from 'preact'
import formatDateInLocalTimezone from '../../utils/dateFormatting'

interface Props {
  lastActive: number | string
  isInvite: boolean
}

const LastActiveCell = () => {
  return ({ lastActive, isInvite }: Props) => {
    if (!lastActive) {
      return null
    }

    return <div class='team-overview__table-last-active'>
      {isInvite ? lastActive : formatDateInLocalTimezone(lastActive)}
    </div>
  }
}

export default LastActiveCell
